import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationStart } from '@angular/router';

import { merge, throwError as _throw } from 'rxjs';
import { switchMap, tap, filter, takeUntil } from 'rxjs/operators';

import { DlgGetAccessComponent } from './dlg-get-access';

interface IGetAccessData {
    amount: number;
}

@Injectable()
export class ShowDlgGetAccessService {
    constructor(
        private _router: Router,
        private _dialog: MatDialog,
    ) {
    }

    show(data: IGetAccessData): Promise<number> {
        const dialogRef = this._dialog.open(DlgGetAccessComponent, {
            panelClass: ['--ui'],
            data
        });

        this._router.events.pipe(
            takeUntil(dialogRef.afterClosed()),
            filter(e => e instanceof NavigationStart),
            tap(() => dialogRef.close()),
        ).subscribe();

        const source = dialogRef.afterClosed();
        const success$ = source
            .pipe(filter<number>((val) => Number(val) > 0));
        const error$ = source
            .pipe(filter<any>((val) => Number(val) <= 0 || !val))
            .pipe(switchMap((error) => _throw(`${ error }`)));

        return merge(success$, error$).toPromise();
    }
}